export const SOFTLINE_API_NOTIFICATION = '/v1/notifications';
